// Shared status pill for the receipt module: the single source of the
// status to tone vocabulary. Phase 2 (Dawn's reconciliation) imports this too, so
// a receipt's status looks identical wherever it appears.

import React from 'react';
import { Tag, TagTone } from '../components/ui/Tag';
import type { ReceiptStatus } from './types';

const TONE: Record<string, TagTone | 'accent'> = {
  uploaded:          'neutral',
  processing:        'neutral',
  processing_failed: 'bad',
  needs_review:      'accent',
  submitted:         'info',
  approved:          'good',
  exported:          'good',
  synced:            'good',
  void:              'neutral',
};

const LABEL: Record<string, string> = {
  uploaded: 'detecting', processing: 'detecting', processing_failed: 'failed',
  needs_review: 'to review', submitted: 'submitted', approved: 'approved',
  exported: 'exported', synced: 'synced', void: 'void',
};

export default function StatusPill({
  status,
  className = '',
}: {
  status: ReceiptStatus | string;
  className?: string;
}) {
  return (
    <Tag tone={TONE[status] || TONE.void} className={className}>
      {LABEL[status] || status}
    </Tag>
  );
}
